<template>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm6 md4>
            <fcc-password-reset />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>

<script>
  import FCCPasswordReset from './components/FCCPasswordReset'

  export default {
    data: () => ({
      drawer: null,
    }),
    props: {
      source: String
    },
    components: {
      "fcc-password-reset": FCCPasswordReset
    }
  }
</script>